import { WidgetDefinition } from "./common";
import WidgetType from "../enum/WidgetType";
import AssetContentMode from "../enum/AssetContentMode";


const Video: WidgetDefinition = {

    type: WidgetType.VIDEO,
    className: "widget-video",
    contentComponent: "dmb-widget-content-video",

    settingsSectionComponents: [
        "dmb-section-widget-settings-video",
        "dmb-section-widget-style",
        'dmb-section-widget-animation'
    ],

    defaultSize: {
        width: 0.2,
        height: 0.2
    },

    defaultStyle: {
        opacity: 100
    },

    defaultSettings: (options) => ({
        assetId: null,
        contentMode: AssetContentMode.COVER,
        repeat: true,
    })
};

export default Video;